import cx from 'classnames'
import { PropsWithChildren } from 'react'
import { useHover } from '@react-aria/interactions'

import Styles from './SelectableFile.module.scss'

import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const SelectableFile = ({
  children,
  isSelected,
  onSelect,
  isUsed,
}: PropsWithChildren<{ isSelected: boolean; onSelect: () => void; isUsed?: boolean }>) => {
  const { hoverProps, isHovered } = useHover({})
  const isBrandKitMediaReservationEnabled = useFlipperFlag('brand_kit_media_reservation')

  return (
    <div
      {...hoverProps}
      className={cx(Styles.selectable, { [Styles.isSelected]: isSelected })}
      aria-label=""
      onClick={() => onSelect()}
    >
      {children}
      {isBrandKitMediaReservationEnabled && isUsed && <div className={Styles.used}>Used</div>}
      {(isSelected || isHovered) && (
        <>
          <div className={Styles.checkbox}>
            <Checkbox size={28} aria-label="Selected image" color="var(--selected-fill)" isSelected={isSelected} />
          </div>
        </>
      )}
    </div>
  )
}
